import { Box } from "theme-ui";

export default function CheckmarkIcon(props) {
  return (
    <Box
      as="svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.5 10.5L4.5 14.5L16.5 2.5"
        stroke="black"
        strokeLinecap="round"
      />
    </Box>
  );
}
